// Previously this functions was used for capturing exceptions and sending to Sentry
// Since we aren't using Sentry anymore, it's just throwing the exception
export default function captureError(err) {
  throw err;
}
